<template>
    <v-text-field
        ref="textField"
        :value="formattedValue"
        :label="label"
        :rules="rules"
        :placeholder="placeholder"
        v-on="listeners"
        v-currency="options">
    </v-text-field>
</template>

<script>
    export default {
        name: 'CurrencyField',
        props: {
            label: String,
            rules: Array,
            placeholder: {
                type: String,
                default: '0,00 €',
            },
            value: {
                type: Number,
                default: null,
            },
            currency: {
                type: String,
                default: 'EUR'
            },
            locale: {
                type: String,
                default: 'de-DE'
            },
            distractionFree: {
                type: [Boolean, Object],
                default() {
                    return {
                        hideNegligibleDecimalDigits: false,
                        hideCurrencySymbol: true,
                        hideGroupingSymbol: true
                    }
                },
            },
            decimalLength: {
                type: Number,
                default: 2
            },
            min: {
                type: Number,
                default: 0
            },
            max: {
                type: Number,
                default: 999999999999
            },
            validateOnInput: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                formattedValue: this.toDecimal(this.value),
            }
        },
        watch: {
            value(value) {
                value = this.toDecimal(value);
                const event = document.createEvent('CustomEvent');
                event.initCustomEvent('format', true, true, {value});
                this.$refs.textField.$refs.input.dispatchEvent(event);
            }
        },
        computed: {
            options() {
                const options = {...this.$CI_DEFAULT_OPTIONS};
                Object.keys(options).forEach((key) => {
                    if (this[key] !== undefined) {
                        options[key] = this[key]
                    }
                });
                return options
            },
            listeners() {
                const {input, ...listeners} = this.$listeners; // all but input event
                return {
                    ...listeners,
                    'format-complete': ({detail}) => {
                        let value = detail.numberValue === null ? null : Math.floor(detail.numberValue * 100);
                        this.$emit('input', value);
                        this.formattedValue = this.$refs.textField.$refs.input.value;
                    }
                };
            }
        },
        methods: {
            toDecimal(value) {
                if (value === null || value === undefined) {
                    return value;
                }
                return Number((value / 100).toFixed(2));
            }
        }
    }
</script>

<style scoped>
    .padding-prefix input {
        padding-left: 8px !important;
    }
</style>
